function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  document.querySelector("body").classList.add("overflow-hidden");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
  document.querySelector("body").classList.remove("overflow-hidden");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // Submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Update cart
    await updateCartDrawer();

    // Open cart drawer
    openCartDrawer();
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

//CART UPSELL
// Add event listeners to the "Hinzufügen" buttons
document.querySelectorAll(".openUpsell").forEach((button) => {
  button.addEventListener("click", (event) => {
    event.preventDefault(); // Prevent default navigation or form submission

    // Fetch data from the button's data-* attributes
    const upsellId = event.target.dataset.upsellId;
    const imageUrl = event.target.dataset.imageUrl;
    const title = event.target.dataset.title;
    const firstPrice = event.target.dataset.firstPriceAvailable;
    const comparedPrice = event.target.dataset.firstComparedPrice;
    const variants = JSON.parse(event.target.dataset.variants);
    const options = JSON.parse(event.target.dataset.options);

    if (variants && variants.length > 0) {
      let variantsDropdown = `
      <select id="upsellVariantSelect">`;
      // let optionsOneArr = variants.map((variant) => {
      //   return variant.option1;
      // });

      // console.log("optionsOneArr: ", optionsOneArr);

      // Create dropdown options for each variant
      variants.forEach((variant) => {
        // console.log("variant: ", variant);
        variantsDropdown += `
        <option value="${variant.id}" data-price="${variant.price}" data-compared-price="${variant.compare_at_price}" data-variant-title="${variant.title}">${variant.title}</option>`;
      });

      variantsDropdown += `</select>`;

      // Insert the dropdown into the modal content
      const modalContent = `
      <div class="MyCartUpsells_MainContainer">
        <button onclick="closeUpsell()" class="cart-upsell-close">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div class="cart-upsell-product-details">
          <div class="cart-upsell-image">
            <img src="${imageUrl}" alt="${title}" class="MyCartUpsells_Image" />
          </div>
          <div class="cart-upsell-product">
            <h4>${title}</h4>
            <div class="cart-upsell-product-price">
              <div class="item-price sale-price" id="salePrice">${firstPrice}</div>
              <div class="item-price regular-price" id="comparedPrice">${comparedPrice}</div>
            </div>

            ${variantsDropdown}
            
            <button onclick="addVariantToCart(${upsellId})" class="add-to-cart" id="addUpsellToCartButton">
              Hinzufügen
            </button>
          </div>
        </div>
      </div>
      `;

      // Render the modal
      // showModal(modalContent);
      // Render the modal
      const modal = document.getElementById("upsellModal");

      modal.innerHTML = modalContent;

      // Get the select element
      const upsellVariantSelect = document.getElementById(
        "upsellVariantSelect"
      );

      // Get the first option's data-variant-title attribute
      const firstOption = upsellVariantSelect.options[0];
      const variantTitle = firstOption.getAttribute("data-variant-title");

      // Check if the variant title is "Default Title"
      if (variantTitle === "Default Title") {
        // Hide the select element
        upsellVariantSelect.style.display = "none";
      }

      document
        .getElementById("addUpsellToCartButton")
        .addEventListener("click", () => {
          const selectedVariantId = document.getElementById(
            "upsellVariantSelect"
          ).value;
          addSelectedVariantToCart(selectedVariantId);
        });

      modal.classList.add("modal-active"); // Display the modal

      // Add event listener to the dropdown to update the price
      const variantSelect = document.getElementById("upsellVariantSelect");
      const salePriceEl = document.getElementById("salePrice");
      const comparedPriceEl = document.getElementById("comparedPrice");

      variantSelect.addEventListener("change", (e) => {
        const selectedOption =
          variantSelect.options[variantSelect.selectedIndex];
        const newPrice = selectedOption.dataset.price;
        const newComparedPrice = selectedOption.dataset.comparedPrice;

        console.log("newPrice: ", formatPrice(newPrice));
        console.log("newComparedPrice: ", formatPrice(newComparedPrice));

        // Update the displayed prices
        // salePriceEl.textContent =
        //   formatPrice(newPrice) || formatPrice(firstPrice);
        // comparedPriceEl.textContent =
        //   formatPrice(newComparedPrice) || formatPrice(comparedPrice);
        salePriceEl.textContent = formatPrice(newPrice) || firstPrice;
        comparedPriceEl.textContent =
          formatPrice(newComparedPrice) || comparedPrice;
      });
    }
  });
});

// Helper function to format price into "55,95 €"
// function formatPrice(price) {
//   return new Intl.NumberFormat("de-DE", {
//     style: "currency",
//     currency: "EUR",
//     minimumFractionDigits: 2, // Ensure two decimal places are displayed
//     maximumFractionDigits: 2, // Prevent unintended decimals
//   }).format(price);
// }
function formatPrice(price) {
  // Divide by 100 to convert 7900 to 79.00
  const adjustedPrice = price / 100;

  // Format the adjusted price
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(adjustedPrice);
}

// Function to create and display the modal
function showModal(content) {
  const modalContainer = document.createElement("div");
  modalContainer.id = "upsell-modal"; // Modal ID for styling
  modalContainer.innerHTML = content; // Inject the content into the modal
  document.body.appendChild(modalContainer); // Append modal to the body
}

// Function to handle adding upsell products to the cart
async function addSelectedVariantToCart(variantId, quantity = 1) {
  try {
    // Add the selected variant to the cart using Shopify's AJAX API
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add the product to the cart");
    }

    const cartItem = await response.json();
    // console.log("Product added to cart:", cartItem);

    // Update the floating cart drawer
    await updateCartDrawer();
    closeUpsell();

    // Open the cart drawer to reflect the changes
    openCartDrawer();
  } catch (error) {
    console.error("Error adding product to cart:", error);
    alert("Something went wrong while adding the product to the cart.");
  }
}

// Function to close and remove the modal
function closeUpsell() {
  document.querySelector("#upsellModal").classList.remove("modal-active");
}
// Function to add the selected variant to the cart
function addVariantToCart(productId) {
  const selectedVariantId = document.querySelector(
    "#upsellVariantSelect"
  ).value;

  // Add to cart API call (Shopify Ajax API)
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: selectedVariantId,
      quantity: 1,
    }),
  })
    .then((response) => {
      if (response.ok) {
        // alert("Product added to cart!");
        closeUpsell();
      } else {
        // alert("Failed to add product to cart.");
      }
    })
    .catch((error) => console.error("Error:", error));
}
